import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { installClientLog } from './lib/clientLog';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { ToastProvider } from './components/ui';
import { ApiError } from './lib/api';
import { AuthProvider } from './lib/auth';
import { registerServiceWorker } from './lib/pwa';
import { ThemeProvider } from './lib/theme';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      refetchOnWindowFocus: true,
      // Never retry what the server refused on purpose.
      retry: (n, e) => !(e instanceof ApiError && e.status >= 400 && e.status < 500) && n < 2,
    },
  },
});

async function boot() {
  // Dev-only fake API for building screens before D1 lands: VITE_MOCK_API=1 npm run dev.
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === '1') await (await import('./dev/mockApi')).installMockApi();
  registerServiceWorker();
  installClientLog();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <BrowserRouter>
            <AuthProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </AuthProvider>
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
